import * as React from 'react';
import { useStrict } from 'mobx';
useStrict(true);
import { observer } from 'mobx-react';
import { Router, Route, Redirect, Switch } from 'react-router-dom';

import { inject } from '../utils/decorators';
import { UiStore } from '../stores/UiStore';
import PrivateRoute from './site/PrivateRoute';
import Header from './site/Header';
import Footer from './site/Footer';
import Content from './site/Content';
import Login from './user/Login';
import Profile from './user/Profile';
import ToastContainer from './site/ToastContainer';
import AuftragDetailRouter from './auftraege/AuftragDetailRouter';
import AuftragAnlegenSES from './auftraege/AuftragAnlegenSES';
import AuftragAnlegenAGT from './auftraege/AuftragAnlegenAGT';
import AuftragAnlegenDMG from './auftraege/AuftragAnlegenDMG';
import QmDokumentation from './user/QmDokumentation';
import Kontakt from './site/Kontakt';
import Portalinfos from './site/Portalinfos';
import FeedbackForm from './site/FeedbackForm';
import ArbeitsmittelAuswahl from './arbeitsmittel/ArbeitsmittelAuswahl';
import AuftragUebersichtLizenz from './auftraege/AuftragUebersichtLizenz';
import Benachrichtigung from './site/Benachrichtigung';
import AuftragUebersichtEigene from './auftraege/AuftragUebersichtEigene';
import AuftragNeu from './auftraege/AuftragNeu';
import AuftragAnlegenBPS from './auftraege/AuftragAnlegenBPS';
import DokumentePublic from './public/DokumentePublic';
import HeaderExtern from './public/HeaderPublic';
import Rechnungen from './belege/Belege';
import BelegDetails from './belege/BelegDetails';

export class PublicLayout extends React.Component<{}, {}> {
    render() {
      return (
        <div className="App">
          <HeaderExtern />
          <Content>
            <Switch>
              <Route path="/public/docs/:guid" component={DokumentePublic}/>
              <Redirect to="/login" />
            </Switch>
          </Content>
          <Footer />
        </div>
      );
    }
}

export class ProtectedLayout extends React.Component<{}, {}> {

  @inject(UiStore) private uiStore: UiStore;

  render() {
    return (
      <div className="App">
        <Header />
        <Benachrichtigung />

        <Content>
          <Switch>
            <Route path="/login" component={Login}/>
            <PrivateRoute path="/profile" component={Profile}/>
            <PrivateRoute path="/kontakt" component={Kontakt}/>
            <PrivateRoute path="/portal" component={Portalinfos}/>
            <PrivateRoute path="/auftraege" exact={true} render={() => <AuftragUebersichtEigene />}/>
            {this.uiStore.userProfile && this.uiStore.userProfile.projektleiter && <PrivateRoute path="/auftraege/lizenz" exact={true} render={() => <AuftragUebersichtLizenz />}/>}
            <PrivateRoute path="/auftrag/neu" exact={true} render={() => <AuftragNeu />}/>
            <PrivateRoute path="/auftrag/neu/ses" exact={true} render={() => <AuftragAnlegenSES />}/>
            <PrivateRoute path="/auftrag/neu/agt" exact={true} render={() => <AuftragAnlegenAGT />}/>
            <PrivateRoute path="/auftrag/neu/bps" exact={true} render={() => <AuftragAnlegenBPS />}/>
            <PrivateRoute path="/auftrag/neu/dmg" exact={true} render={() => <AuftragAnlegenDMG />}/>
            <PrivateRoute path="/auftrag/:auftragId" component={AuftragDetailRouter} />
            <PrivateRoute path="/qm" component={QmDokumentation}/>
            <PrivateRoute path="/arbeitsmittel" exact={true} render={() => <ArbeitsmittelAuswahl title={'Arbeitsmittel-Sets'} uebersicht={true} />} />
            <PrivateRoute path="/arbeitsmittel/:arbeitsmittelId/feedback" component={FeedbackForm} />
            <PrivateRoute path="/belege" component={Rechnungen} />
            <PrivateRoute path="/beleg/:renr" component={BelegDetails} />
            <Redirect to="/auftraege" />
          </Switch>
        </Content>

        <ToastContainer />
        <Footer />
      </div>
    );
  }
}

@observer
export default class App extends React.Component<{}, {}> {

  @inject(UiStore) private uiStore: UiStore;

  render() {
    return (
      <Router history={this.uiStore.history}>
        <Switch>
          <Route path="/public/" component={PublicLayout} />
          <Route path="/" component={ProtectedLayout} />
        </Switch>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/App.tsx